import React, { useEffect, useState } from "react";
import { GetMasterPhonePrefix, GetMasterCountry } from "../../services/MasterCallsService";
import { FormControl, InputLabel, Select } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { checkIsNullUndefined } from "../../commons/Utils";
import { EnumCountries } from "../../commons/EnumCountries";
import { CommonStyles } from "../../commons/CommonStyles";
// import { getSessionItem, setSessionItem } from "../../services/Commons";


export function PrefixPhone(props) {
  const { handleSelectorChange, isLogin, masterCountryList, disabled, country, countryPrefixList } = props;
  const commonClasses = CommonStyles();
  const { t } = useTranslation();

  const [countryList, setCountryList] = useState([]);
  const [countrySelected, setCountrySelected] = useState({ id: "" });

  useEffect(() => {
    if (isLogin) {
      setLoginPath();
    } else {
      prepareComponent();
    };
  }, []);

  const setLoginPath = () => {
    if (masterCountryList && masterCountryList.length > 0) {
      setSpainDefault(masterCountryList);
    } else {
      GetMasterCountry().then((response) => {
        if (response && !response.Status) {
          setSpainDefault(response);
        };
      });
    };
  };

  const prepareComponent = () => {
    if (countryPrefixList && countryPrefixList.length > 0) {
      setFirstCountry(countryPrefixList);
    } else {
      GetMasterPhonePrefix().then((response) => {
        //comprobamos que no sea null o error
        if (response && !response.Status) {
          setFirstCountry(response);
        }
      });
    };
  };

  const setFirstCountry = (auxPrefixesList) => {
    if (!checkIsNullUndefined(country) && !checkIsNullUndefined(country.code)) {
      let found = auxPrefixesList.find((auxCountry) => auxCountry.code == country.code);
      if (found) {
        setValues(auxPrefixesList, found);
      } else {
        getCountry(auxPrefixesList);
      };
    } else {
      setSpainDefault(auxPrefixesList);
    };
  };

  const setValues = (auxPrefixesList, auxCountry) => {
    setCountryList(auxPrefixesList);
    setCountrySelected(auxCountry);
    handleSelectorChange(auxCountry);
  };

  const setSpainDefault = (auxPrefixesList) => {
    auxPrefixesList.forEach((auxCountry) => {
      if (auxCountry.code == EnumCountries.ESP) {
        setValues(auxPrefixesList, auxCountry);
      };
    });
  };

  const getCountry = (auxPrefixesList) => {
    if (checkIsNullUndefined(masterCountryList) || masterCountryList.length === 0) {
      GetMasterCountry().then((response) => {
        if (response && !response.Status) {
          let found = response.find((auxCountry) => auxCountry.code == country.code);
          auxPrefixesList.push(found);
          setValues(auxPrefixesList, found);
        }
      });
    } else {
      let found = masterCountryList.find((auxCountry) => auxCountry.code == country.code);
      auxPrefixesList.push(found);
      setValues(auxPrefixesList, found);
    };
  };

  // Maneja el cambio en el selector de prefijo
  const handlePrefixChange = (event) => {
    const selected = countryList.find((auxCountry) => auxCountry.id == event.target.value);
    if (selected) {
      setCountrySelected(selected);
      handleSelectorChange(selected);
    }
  };

  return (
    <FormControl variant={"filled"} fullWidth className={commonClasses.inputsStyle}>
      <InputLabel htmlFor="phoneSelector" id="phoneSelector-label" color="secondary">
        {t("prefixSelector")}
      </InputLabel>
      <Select
        color="secondary"
        native
        labelId="phoneSelector-label"
        id="phoneSelector"
        label={t("prefixSelector")}
        value={countrySelected.id}
        disabled={disabled}
        onChange={handlePrefixChange}
      >
        {countryList.map((auxCountry) => {
          return (
            <option key={auxCountry.code} value={auxCountry.id}>
              {auxCountry.code + " (+" + auxCountry.phonePrefix + ")"}
            </option>
          );
        })}
      </Select>
    </FormControl>
  );
}
